import { render, staticRenderFns } from "./GoToFilesLogin.vue?vue&type=template&id=65361488&scoped=true&"
import script from "./GoToFilesLogin.vue?vue&type=script&lang=js&"
export * from "./GoToFilesLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoToFilesLogin.css?vue&type=style&index=0&id=65361488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65361488",
  null
  
)

export default component.exports